import React, { useEffect, useRef, useState } from "react";
import "./Prie.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
  IconButton,
  Tooltip,
} from "@mui/material";
import phone from "../../../Assets/phone.svg";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import linkedin from "../../../Assets/linkedin.svg";
import LinkedINImage from "../../../Assets/linkedin.svg";
import massageicon from "../../../Assets/FrameDiff.svg";
import company from "../../../Assets/people-logo.png";
import education from "../../../Assets/cap-logo.png";
import experience from "../../../Assets/jobcompany.png";
import ReplayIcon from "@mui/icons-material/Replay";
import visitLinkImage from "../../../Assets/visit-link.svg";
import { APIDataUrl, APITokenUrl } from "../../../Utils/Utils";
import axios from "axios";
import { CloseOutlined } from "@mui/icons-material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import partnerimg from "../../../Assets/partnerimg.svg";
import joformarimg from "../../../Assets/joformernew.svg";
import moment from "moment";
import PrieMenuIndirect from "./PrieMenuIndirect";
import { APP_CONFIG } from "../../../Utils/env";

const PrieIndirectPath = ({
  dataForInformation,
  crieData,
  setCrieData,
  crieSrcList,
  associateList,
  setAssociateList,
  setLoading,
  handleRadioChange,
  selectedValue,
  getCrieIndirectdata,
  disabledIndirect,
  inDirectSummary,
  strengthList,
  setStrengthList,
  crieStrengthList,
  baseIndirectCount,
  setIndirectCount,
  setModalOpenRefresh,
  isDownloading,
  
  
  indirectCount,
}) => {
  const [visibleItems, setVisibleItems] = useState(10);
  const navigate = useNavigate();
  const itemsPerLoad = 10;
  const handleLoadMore = () => {
    setVisibleItems((prevVisibleItems) => prevVisibleItems + itemsPerLoad);
  };
  const location = useLocation();

  const combineNodesAndEdges = (nodes, edges) => {
    const combinedArray = [];

    edges?.forEach((edge) => {
      const sourceNode = nodes?.find((node) => node.joi_id === edge.src_id);
      const targetNode = nodes?.find((node) => node.joi_id === edge.dst_id);
      if (sourceNode && targetNode) {
        combinedArray.push({
          ...sourceNode,
          ...edge,
          target: targetNode.uid,
        });
      }
    });
    const lastEdgeDstId = edges[edges.length - 1]?.dst_id;
    const lastNode = nodes?.find((node) => node.joi_id === lastEdgeDstId);
    // const lastNode = nodes?.find((node) => !edges.some((edge) => edge.src_id === node.joi_id));

    if (lastNode) {
      combinedArray.push(lastNode);
    }

    return combinedArray;
  };

  const arraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    return arr1.slice().sort()?.toString() === arr2.slice().sort()?.toString();
  };

  const matchJoiIds = (newda, item) => {
    const pathOrder =
      newda?.detail?.path_order[item]?.map((item, index, arr) => ({
        src: item,
        dst: arr[index + 1] || String(dataForInformation?.person_id),
        joi_id: [
          String(item),
          arr[index + 1]
            ? String(arr[index + 1])
            : String(dataForInformation?.person_id),
        ],
      })) || [];

    const pathsData =
      newda?.detail?.paths[item]?.map((i) => ({
        joi_id: [String(i?.src_id), String(i?.dst_id)],
        relation: i?.relation,
        weight: i?.weight,
        last_date: i?.last_date,
      })) || [];

    const matchedData = pathOrder
      .map((orderItem) => {
        const matchedPath = pathsData.find((pathItem) =>
          arraysEqual(pathItem.joi_id, orderItem.joi_id),
        );
        if (matchedPath) {
          return {
            src_id: String(orderItem.src),
            dst_id: String(orderItem.dst),
            relation: matchedPath.relation,
            weight: matchedPath.weight,
            last_date: matchedPath.last_date,
          };
        }
        return null;
      })
      .filter((item) => item !== null);
    return matchedData;
  };

  // Jo Associate
  const [isMenuAssociate, setIsMenuAssociate] = React.useState(false);
  const [associate, setAssociate] = React.useState([]);

  const handleChangeAssociate = (event, item) => {
    if (event.target.checked) {
      setAssociate([...associate, item]);
    } else {
      setAssociate(associate?.filter((uncheck) => uncheck !== item));
    }
  };
  const handleSearchAssociate = (e) => {
    if (e?.length) {
      const data = crieSrcList?.filter((item) =>
        item?.name?.toLowerCase()?.includes(e?.toLowerCase()),
      );
      setAssociateList(data);
    } else {
      setAssociateList(crieSrcList);
    }
  };

  // Path Weight
  const [isMenuPathWeight, setIsMenuPathWeight] = React.useState(false);

  const [pathWeight, setPathWeight] = React.useState([]);

  const handleChangePathWeight = (event, item) => {
    if (event.target.checked) {
      setPathWeight([...pathWeight, item]);
    } else {
      setPathWeight(pathWeight?.filter((uncheck) => uncheck !== item));
    }
  };

  useEffect(() => {
    setAssociate([]);
    setPathWeight([]);
  }, [dataForInformation]);

  const handleSearchCrie = () => {
    if (!associate?.length && !pathWeight?.length) {
      toast.error("Please select filters");
      return;
    } else if (!associate?.length) {
      toast.error("Please select source employee");
      return;
    }
    setCrieData([]);
    const data = {};
    // data.source_id = process.env.REACT_APP_JOI_JO_ID;
    data.source_id = APP_CONFIG.JOI_JO_ID;
    data.target_id = String(dataForInformation?.person_id);
    if (associate?.length) {
      data.person_source_id = associate;
    }
    // data.person_target_id = [];
    // data.person_mid_id = [];
    if (pathWeight?.length) {
      data.filter_strength = pathWeight;
    }
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      data: data,
      url: `${APIDataUrl()}/v1/prie_get_indirect_path`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);

        if (e?.status === 200) {
          let data = e?.data;

          if (e?.data?.detail) {
            let addingAlternate = [];
            setIndirectCount(
              Object.keys(data?.detail?.path_order)?.length || 0,
            );
            const sortedPathKeys = Object.keys(data?.detail?.path_order).sort(
              (a, b) =>
                data?.detail?.strength_order.indexOf(a) -
                data?.detail?.strength_order.indexOf(b),
            );

            sortedPathKeys.forEach((item) => {
              const match = matchJoiIds(data, item);

              const upcomingAlternate = combineNodesAndEdges(
                data?.detail?.nodes,
                match,
              );

              let updatedAlternate = [];
              let newAlternate = [];
              upcomingAlternate?.forEach((item, index) => {
                updatedAlternate.push(item);
                if (
                  (index + 1) % 3 === 0 ||
                  index === upcomingAlternate.length - 1
                ) {
                  newAlternate.push(updatedAlternate);
                  updatedAlternate = [];
                }
              });

              addingAlternate.push(newAlternate);
            });
            // Sort the crieData based on the sum of weights
            const sortedCrieData = addingAlternate.sort((a, b) => {
              const sumWeightsA = a
                .flat()
                .reduce((sum, item) => sum + (item.weight || 0), 0);
              const sumWeightsB = b
                .flat()
                .reduce((sum, item) => sum + (item.weight || 0), 0);
              return sumWeightsB - sumWeightsA; // Sort in descending order
            });
            setCrieData(sortedCrieData);
          } else {
            setCrieData([]);
            setIndirectCount(0);
          }
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const handleResetFilter = () => {
    setCrieData([]);
    setAssociate([]);
    setPathWeight([]);
    setAssociateList(crieSrcList);
    setStrengthList(crieStrengthList);
    setIndirectCount(baseIndirectCount);
    localStorage.removeItem("cip");
  };

  const joRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (joRef.current && !joRef.current.contains(event.target)) {
        setIsMenuAssociate(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [joRef]);
  const pathRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pathRef.current && !pathRef.current.contains(event.target)) {
        setIsMenuPathWeight(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [pathRef]);

  const handleIndirectPathClick = (i) => {
    if (i?.src_id) {
      navigate(`/Profile/${i.src_id}`);
    } else if (i?.joi_id) {
      navigate(`/Profile/${i.joi_id}`);
    }
  };

  const getDaysDifference = (date) => {
    const diff = moment().diff(moment(date), "days");

    if (diff >= 366) {
      return { text: "1 year+", color: "rgb(207 74 74)" };
    } else if (diff >= 181) {
      return { text: "< 1 year", color: "#EC971E" };
    } else if (diff >= 91) {
      return { text: "< 6 months", color: "#C601A2" };
    } else if (diff >= 31) {
      return { text: "< 3 months", color: "#0195C6" };
    } else {
      return { text: "< 1 month", color: "rgb(90 194 157)" };
    }
  };
  const getInitials = (name) => {
    return name
      ?.split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <>
      // web view
      <div>
        <div className="crie-filter-inner-container crie-cont-2 do_not_print">
          <div className="crie-inner-drop-boxes">
            {/* Jo Associate */}
            <div className="crie_outer_drop">
              <div
                className="crie-drop-down"
                style={{ textTransform: "none" }}
                onClick={() => {
                  setIsMenuAssociate(!isMenuAssociate);
                  setIsMenuPathWeight(false);
                }}
              >
                JO Employee
                <KeyboardArrowDownIcon />
              </div>
              <div ref={joRef}>
                <PrieMenuIndirect
                  isMenuOpen={isMenuAssociate}
                  alldata={associateList}
                  handleCheckboxChange={handleChangeAssociate}
                  checked={associate}
                  handleSearch={handleSearchAssociate}
                  isSearch={true}
                />
              </div>
            </div>

            {/* Path weight */}
            <div className="crie_outer_drop">
              <div
                className="crie-drop-down"
                onClick={() => {
                  setIsMenuPathWeight(!isMenuPathWeight);
                  setIsMenuAssociate(false);
                }}
              >
                Path Strength
                <KeyboardArrowDownIcon />
              </div>
              <div ref={pathRef}>
                <PrieMenuIndirect
                  isMenuOpen={isMenuPathWeight}
                  alldata={strengthList}
                  handleCheckboxChange={handleChangePathWeight}
                  checked={pathWeight}
                  isSearch={false}
                />
              </div>
            </div>
            <Button
              onClick={handleSearchCrie}
              className="crie-filter-inner-container-search"
            >
              Search
            </Button>
            {/* Reset Filter */}
            <div className="crie_outer_drop">
              <div
                className="inner-rest-button-crie"
                onClick={handleResetFilter}
              >
                <ReplayIcon className="reset-tick-icon" />
                Reset Filter
              </div>
            </div>
          </div>
          {disabledIndirect === "processing" ? (
            <Button
              className="crie-filter-inner-container-crie"
              onClick={() => setModalOpenRefresh(true)}
            >
              Refresh Indirect Paths
            </Button>
          ) : null}
          {disabledIndirect === "refresh" ? (
            <div className="crie_indirect_process">
              <p>Indirect Paths In Process</p>
              <Button className="crie-filter-inner-container-crie-disabled">
                Refresh Indirect Paths
              </Button>
            </div>
          ) : null}
        </div>
        <div className="crie-filter-inner-container cre-list-cont">
          <div className="crie-inner-drop-boxes-2">
            {associate?.length ? (
              <>
                {associate?.map((item) => (
                  <div className="crie_selected_names">
                    {associateList?.find((i) => i?.joi_id == item)?.name}{" "}
                    <CloseOutlined
                      onClick={() =>
                        setAssociate(
                          associate?.filter((uncheck) => uncheck !== item),
                        )
                      }
                    />
                  </div>
                ))}
              </>
            ) : null}
          </div>

          <div className="crie-inner-drop-boxes-2">
            {pathWeight?.length ? (
              <>
                {pathWeight?.map((item) => (
                  <div className="crie_selected_names">
                    {strengthList?.find((i) => i?.joi_id == item)?.name}{" "}
                    <CloseOutlined
                      onClick={() =>
                        setPathWeight(
                          pathWeight?.filter((uncheck) => uncheck !== item),
                        )
                      }
                    />
                  </div>
                ))}
              </>
            ) : null}
          </div>
        </div>
        {/* <div className='crie-cont crie_direct'>Direct Connection Paths</div> */}
        <div style={{ padding: "20px" }}>
          <div className="path-graph-crie">
            {/* <div className='radio-input-crie'> <div className='direct-path-crie'><input type="radio" /><p>Direct Paths</p></div> <div className='in-direct-path-crie'><input type="radio" /><p>In-Direct Paths</p></div></div> */}
            <div className="radio-input-crie">
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  className="rg-direct-paths"
                  onChange={(e) => handleRadioChange(e)}
                >
                  <FormControlLabel
                    className="direct-path-crie"
                    checked={selectedValue === "direct"}
                    value="direct"
                    control={<Radio />}
                    label="Direct Paths"
                  />
                  <FormControlLabel
                    className={
                      disabledIndirect == "pending" ||
                      disabledIndirect === "submitted"
                        ? "in-direct-path-crie"
                        : "direct-path-crie"
                    }
                    checked={selectedValue === "indirect"}
                    value="indirect"
                    disabled={
                      disabledIndirect == "pending" ||
                      disabledIndirect === "submitted"
                    }
                    control={<Radio />}
                    label="Indirect Paths"
                  />
                </RadioGroup>
              </FormControl>
            </div>
            {disabledIndirect === "submitted" ? (
              <>
                <div className="crie_path_cont">
                  <i>
                    Indirect Path request for this organization has already
                    been submitted and will be available soon.
                  </i>
                </div>
              </>
            ) : crieData?.length ? (
              <div className="print-div-full">
                {crieData.slice(0, visibleItems).map((myItem, index) => {
                  return myItem.length ? (
                    <>
                      <div
                        className="AllAIOuttercontainer-sidebar_crie"
                        key={index}
                        style={{ pageBreakInside: "avoid" }}
                      >
                        <p className="path_head">Path {index + 1}</p>
                        <div className="AllAi-paths-list">
                          {myItem?.map((item, index) => (
                            <>
                              <div className="siderbar-row">
                                {item?.map((i, idx) => (
                                  <div
                                    style={{ display: "flex" }}
                                    className="innerData_ai_cont_crie"
                                  >
                                    <div
                                      className="first_crie_box_2"
                                      onClick={() =>
                                        handleIndirectPathClick(i)
                                      }
                                    >
                                      <div className="crie_info">
                                        <div className="crie_name">
                                          {i?.name}
                                          <p className="formerjo-p">
                                            {i.former_jo ? (
                                              <img
                                                src={joformarimg}
                                                alt=""
                                                className="jo-former-icon"
                                              />
                                            ) : null}
                                          </p>
                                        </div>
                                        <div>
                                          {i?.primary_organization?.length >
                                          25
                                            ? i?.primary_organization.substr(
                                                0,
                                                25,
                                              ) + "..."
                                            : i?.primary_organization}
                                        </div>
                                        <a className="company-profile-mention">
                                          {" "}
                                          <EmailOutlinedIcon
                                            style={{
                                              color: "#003057",
                                              width: "15px",
                                              height: "15px",
                                            }}
                                          />
                                          {i?.email
                                            ? i?.email.split(",")[0]
                                            : "--"}
                                        </a>
                                        <a className="company-profile-mention">
                                          {" "}
                                          <img
                                            src={phone}
                                            alt=""
                                            style={{
                                              width: "13px",
                                              height: "13px",
                                            }}
                                          />
                                          {i?.phone ? i?.phone : "--"}{" "}
                                        </a>
                                        <p className="company-profile-mention-2">
                                          <span>
                                            <img
                                              src={linkedin}
                                              alt=""
                                              style={{
                                                width: "14px",
                                                height: "14px",
                                              }}
                                            />
                                            {i?.linkedin
                                              ? "Linkedin Profile"
                                              : "--"}
                                          </span>
                                          {i?.linkedin ? (
                                            <a
                                              href={i?.linkedin}
                                              className="crie-a-end"
                                              target="_blank"
                                            >
                                              {" "}
                                              <img
                                                src={visitLinkImage}
                                                alt=""
                                                style={{
                                                  width: "14px",
                                                  height: "14px",
                                                }}
                                              />
                                            </a>
                                          ) : (
                                            <a></a>
                                          )}{" "}
                                        </p>
                                      </div>
                                    </div>
                                    {i?.relation && (
                                      <div className="relation_ai_path_cont_2">
                                        <hr className="horizontal-line-in-aipath" />
                                        <div className="siderbar-image-container relative-crie">
                                          {/* {
                                                                                  i?.last_date ?
                                                                                      <div className='crie-indays'>{getDaysDifference(i?.last_date)}</div> : null
                                                                              } */}
                                          {i?.last_date &&
                                          i?.last_date !== "-" ? (
                                            <div
                                              className="crie-indays"
                                              style={{
                                                background: getDaysDifference(
                                                  i?.last_date,
                                                ).color,
                                              }}
                                            >
                                              {
                                                getDaysDifference(
                                                  i?.last_date,
                                                ).text
                                              }
                                            </div>
                                          ) : null}
                                          <div className="Siderbar-lits-images">
                                            <Tooltip
                                              title={
                                                "Weighted Connection Strength"
                                              }
                                            >
                                              <div className="weight-between-nodes-crie">
                                                {i?.weight}
                                              </div>
                                            </Tooltip>
                                            <Tooltip
                                              title={"Email Exchanged"}
                                            >
                                              {i?.relation?.includes(
                                                "Email",
                                              ) && (
                                                <img
                                                  src={massageicon}
                                                  alt=""
                                                  className="siderbar-modal-img-crie"
                                                />
                                              )}
                                            </Tooltip>
                                            <Tooltip
                                              title={"LinkedIn Connection"}
                                            >
                                              {i?.relation?.includes(
                                                "LinkedIn",
                                              ) && (
                                                <img
                                                  src={LinkedINImage}
                                                  alt=""
                                                  className="siderbar-modal-img-crie"
                                                />
                                              )}
                                            </Tooltip>
                                            <Tooltip
                                              title={
                                                "Working in Same Company"
                                              }
                                            >
                                              {i?.relation?.includes(
                                                "Organization",
                                              ) && (
                                                <img
                                                  src={company}
                                                  alt=""
                                                  className="siderbar-modal-img-crie"
                                                />
                                              )}
                                            </Tooltip>
                                            <Tooltip
                                              title={"Attended Same College"}
                                            >
                                              {i?.relation?.includes(
                                                "Education",
                                              ) && (
                                                <img
                                                  src={education}
                                                  alt=""
                                                  className="siderbar-modal-img-crie"
                                                />
                                              )}
                                            </Tooltip>
                                            <Tooltip
                                              title={
                                                "Previously Worked in Same Organization"
                                              }
                                            >
                                              {i?.relation?.includes(
                                                "Experience",
                                              ) && (
                                                <img
                                                  src={experience}
                                                  alt=""
                                                  className="siderbar-modal-img-crie"
                                                />
                                              )}
                                            </Tooltip>
                                            <Tooltip title={"Meeting"}>
                                              {i?.relation?.includes(
                                                "Meeting",
                                              ) && (
                                                <CalendarMonthIcon className="siderbar-modal-img-crie" />
                                              )}
                                            </Tooltip>
                                            <Tooltip
                                              title={"Regional Partner"}
                                            >
                                              {i?.relation?.includes(
                                                "Partner",
                                              ) && (
                                                <img
                                                  src={partnerimg}
                                                  alt=""
                                                  className="siderbar-modal-img"
                                                />
                                              )}
                                            </Tooltip>
                                          </div>
                                        </div>
                                        <div className="connecting-line"></div>
                                      </div>
                                    )}
                                  </div>
                                ))}
                              </div>
                              {index < myItem?.length - 1 && (
                                <div className="container-of-joint-line-of-node2-sidebar_crie">
                                  <p className="top-line-of-nodes2_crie"></p>
                                  <div className="main-for-nodes-line2_crie"></div>
                                  <p className="bottom-line-of-nodes2"></p>
                                </div>
                              )}
                            </>
                          ))}
                        </div>
                        {isDownloading ? (
                          <p>
                            Disclaimer : You can always update your selections
                            to view more results on your download.
                          </p>
                        ) : null}
                      </div>
                    </>
                  ) : null;
                })}
              </div>
            ) : !associate?.joi_id && !pathWeight?.value ? (
              <div className="crie_path_cont">
                <i>
                  Please use the filter option above to define what In-Direct
                  paths you would like to view.
                </i>
              </div>
            ) : (
              <div className="crie_path_cont">No Records Found !</div>
            )}
            <div className="loadmore-pagination-section">
              {visibleItems < crieData?.length ? (
                <button
                  className="btn-load-more button-loadmore-pagination crie-load-more"
                  onClick={handleLoadMore}
                >
                  Load More
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      {" "}
    </>
  );
};
export default PrieIndirectPath;
